import {modalService} from 'lib/Modal';
import {CartStep, useCartContext} from 'modules/Cart/contexts/cartContext';
import {CART_ORDER_FORM_ID} from 'modules/Cart/lib/constants';
import {useCallback} from 'react';

export function useCartSidebar() {
    const {
        total,
        step,
        setStep,
        orderFormIsValid,
        orderFormIsSubmitting,
        regionalDiscounts,
        shouldApplyRegionalDiscount,
        formSubmitCount,
    } = useCartContext();

    const handleSubmit = useCallback(() => {
        if (step === CartStep.Order) {
            const cartForm = document.getElementById(CART_ORDER_FORM_ID);
            cartForm?.dispatchEvent(
                new Event('submit', {cancelable: true, bubbles: true}),
            );
        } else if (step === CartStep.Products) {
            setStep(CartStep.Order);
        }
    }, [setStep, step]);

    const handleCallback = useCallback(async () => {
        modalService.callbackModal('/windows/callback/');
    }, []);

    const minimalPriceOrder = window.ENV?.regionalSettings?.minOrder || 3000;
    const priceIsTooLow = total.totalPrice < minimalPriceOrder;

    const submitButtonIsDisabled =
        priceIsTooLow || (step === CartStep.Order && orderFormIsSubmitting);

    return {
        total,
        regionalDiscounts,
        shouldApplyRegionalDiscount,
        submitButtonIsDisabled,
        handleSubmit,
        handleCallback,
        priceIsTooLow,
        minimalPrice: minimalPriceOrder,
        step,
        formSubmitCount,
        orderFormIsValid,
    };
}
